import api from './client'

export interface Valuation {
  id: string
  currentValue: number
  asOfDate: string
  createdAt: string
}

export interface RecordValuationPayload {
  currentValue: number
  asOfDate: string
}

export async function listValuations(accountId: string): Promise<Valuation[]> {
  const { data } = await api.get<Valuation[]>(`/financial-accounts/${accountId}/valuations`)
  return data
}

export async function recordValuation(
  accountId: string,
  payload: RecordValuationPayload
): Promise<Valuation> {
  const { data } = await api.post<Valuation>(`/financial-accounts/${accountId}/valuations`, payload)
  return data
}
